var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('c-simple-tooltip',{attrs:{"content":_vm.tooltipContent,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('c-alarm-pbehavior-chip',_vm._g({attrs:{"color":_vm.pbehaviorInfo.color,"icon":_vm.pbehaviorInfo.icon_name}},on))]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }